import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import Button from '../../../components/base/Button';

export default function OilServices() {
  return (
    <div className="min-h-screen" dir="rtl">
      <Header />
      
      {/* Breadcrumb */}
      <div className="bg-gray-50 py-4">
        <div className="container mx-auto px-4">
          <nav className="flex items-center text-sm text-gray-600">
            <Link to="/" className="hover:text-[#E71B25] transition-colors">
              الرئيسية
            </Link>
            <i className="ri-arrow-left-s-line mx-2"></i>
            <Link to="/services" className="hover:text-[#E71B25] transition-colors">
              الخدمات
            </Link>
            <i className="ri-arrow-left-s-line mx-2"></i>
            <span className="text-[#595A5C] font-medium">البترول والطاقة</span>
          </nav>
        </div>
      </div>

      <main className="py-20">
        <div className="container mx-auto px-4">
          {/* Hero Section */}
          <div className="text-center mb-16">
            <h1 className="text-5xl font-bold text-[#595A5C] mb-6">البترول والطاقة</h1>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
              نقدم حلولاً متكاملة لقطاع البترول والطاقة، من توريد المعدات والمواد 
              إلى خدمات التشغيل والصيانة وفق أعلى المعايير الدولية
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-20">
            {/* Service Image */}
            <div className="order-2 lg:order-1">
              <img
                src="https://public.readdy.ai/ai/img_res/e5a3e52a41a51b373781499abf4083d3.jpg"
                alt="البترول والطاقة"
                className="w-full h-96 object-cover rounded-2xl shadow-lg"
              />
            </div>

            {/* Service Content */}
            <div className="order-1 lg:order-2">
              <h2 className="text-3xl font-bold text-[#595A5C] mb-8">نطاق خدماتنا</h2>
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center ml-4 mt-1 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#595A5C] mb-2">توريد معدات ومواد البترول</h3>
                    <p className="text-gray-600">توريد معدات متخصصة ومواد عالية الجودة لصناعة البترول والغاز</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center ml-4 mt-1 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#595A5C] mb-2">خدمات التشغيل والصيانة O&M</h3>
                    <p className="text-gray-600">خدمات شاملة للتشغيل والصيانة لضمان الأداء الأمثل للمعدات</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center ml-4 mt-1 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#595A5C] mb-2">خطوط الأنابيب والخزانات</h3>
                    <p className="text-gray-600">تنفيذ خطوط الأنابيب والخزانات وفق معايير API 650/653</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center ml-4 mt-1 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#595A5C] mb-2">فحوص NDT المتقدمة</h3>
                    <p className="text-gray-600">فحوص الاختبارات غير المدمرة باستخدام أحدث التقنيات</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center ml-4 mt-1 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#595A5C] mb-2">الخدمات اللوجستية</h3>
                    <p className="text-gray-600">حلول لوجستية متكاملة لنقل وتخزين المواد البترولية</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Standards Section */}
          <div className="bg-gray-50 rounded-2xl p-12 mb-20">
            <h2 className="text-3xl font-bold text-[#595A5C] mb-8 text-center">معايير الامتثال والسلامة</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-[#E71B25] rounded-xl flex items-center justify-center mx-auto mb-4">
                  <i className="ri-shield-check-line text-white text-2xl"></i>
                </div>
                <h3 className="font-semibold text-[#595A5C] mb-2">معايير API</h3>
                <p className="text-gray-600">الالتزام بمعايير معهد البترول الأمريكي API 650/653</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-[#E71B25] rounded-xl flex items-center justify-center mx-auto mb-4">
                  <i className="ri-first-aid-kit-line text-white text-2xl"></i>
                </div>
                <h3 className="font-semibold text-[#595A5C] mb-2">معايير HSE</h3>
                <p className="text-gray-600">الالتزام الكامل بمعايير الصحة والسلامة والبيئة</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-[#E71B25] rounded-xl flex items-center justify-center mx-auto mb-4">
                  <i className="ri-search-line text-white text-2xl"></i>
                </div>
                <h3 className="font-semibold text-[#595A5C] mb-2">فحوص NDT</h3>
                <p className="text-gray-600">اختبارات غير مدمرة شاملة لضمان سلامة المعدات</p>
              </div>
            </div>
          </div>

          {/* Why Choose Us */}
          <div className="mb-20">
            <h2 className="text-3xl font-bold text-[#595A5C] mb-12 text-center">لماذا فيبا للتجارة؟</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center bg-white p-8 rounded-2xl shadow-lg">
                <div className="w-20 h-20 bg-[#E71B25] rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <i className="ri-global-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#595A5C] mb-4">شراكات دولية قوية</h3>
                <p className="text-gray-600">علاقات وثيقة مع أفضل الموردين العالميين في قطاع البترول والطاقة</p>
              </div>
              
              <div className="text-center bg-white p-8 rounded-2xl shadow-lg">
                <div className="w-20 h-20 bg-[#E71B25] rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <i className="ri-microscope-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#595A5C] mb-4">تقنيات متطورة</h3>
                <p className="text-gray-600">استخدام أحدث التقنيات والمعدات في الفحص والتشغيل والصيانة</p>
              </div>
              
              <div className="text-center bg-white p-8 rounded-2xl shadow-lg">
                <div className="w-20 h-20 bg-[#E71B25] rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <i className="ri-team-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#595A5C] mb-4">فريق متخصص</h3>
                <p className="text-gray-600">مهندسون وفنيون معتمدون بخبرة واسعة في صناعة البترول والغاز</p>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="text-center bg-[#E71B25] text-white p-12 rounded-2xl">
            <h2 className="text-3xl font-bold mb-6">تحتاج حلولاً بترولية متكاملة؟</h2>
            <p className="text-xl mb-8 opacity-90">
              تواصل معنا للحصول على استشارة مجانية وعرض سعر مخصص لاحتياجاتك في قطاع البترول والطاقة
            </p>
            <Button 
              variant="outline" 
              size="lg" 
              className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-[#E71B25] whitespace-nowrap"
              onClick={() => window.location.href = 'mailto:info@vipatradingco.com'}
            >
              طلب عرض سعر
              <i className="ri-mail-line mr-2"></i>
            </Button>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}